import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../../httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../../httpClient/serverApi/types/IGetItemsResult';
import { INamedItemInfo } from '../../../../spacesPlatform/models/resourceInfoParts';
import { INamedItem, IOwnedItem } from '../../../../spacesPlatform/models/resourceParts';

// Set "withContent" to true to populate the "content" property with the
// content (data sources and workbooks) currently associated with the agent.
export interface IGetRemoteRefreshAgentsParams extends IGetItemsParams {
  withContent?: boolean;
}

export interface IGetRemoteRefreshAgentsResult extends IGetItemsResult {
  agents: IRemoteRefreshAgent[];
}

// An agent is the end-user computer that has the client installed and has been
// explicitly registered by the user, from their computer, for the site.
// This is where the remote refresh is performed.
export interface IRemoteRefreshAgent extends INamedItem, IOwnedItem {
  content?: INamedItemInfo[];
  schedulesSyncedAt?: string;   // ISO 8601 formatted string, or null
  remoteAgentTimeZone?: string; // The time zone of the Tableau Bridge client
}

// Given a user id, get their remote refresh agents.
export class GetRemoteRefreshAgentsRequest extends Request<IGetRemoteRefreshAgentsParams, IGetRemoteRefreshAgentsResult> {
  constructor(params: IGetRemoteRefreshAgentsParams) {
    super('getRemoteRefreshAgents', params);
  }
}
